import { render, staticRenderFns } from "./manage_brands.vue?vue&type=template&id=0f637a3e"
import script from "./manage_brands.vue?vue&type=script&lang=js"
export * from "./manage_brands.vue?vue&type=script&lang=js"
import style0 from "./manage_brands.vue?vue&type=style&index=0&id=0f637a3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports